import React, { useState } from "react";
import InvTr from "./InvTr";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../../../../api/baseUrl";
import { RootState } from "../../../../../redux/store";
import { addInvestigation } from "../../../../../redux/diagnosestate/diagnoseAction";
interface FormData {
  investigation: string;
  toothNo: string;
  surface: string;
  description: string;
}
function Investigation({ setmakeAction, makeAction }: any) {
  const dispatch = useDispatch();
  const { ID } = useParams();

  const [formData, setformData] = useState<FormData>({
    investigation: "",
    toothNo: "",
    surface: "",
    description: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setformData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      // if (!formData.diagnoseId) {
      //   toast.error("Please select a diagnose.");
      //   return;
      // }

      const response = await baseUrl.patch(
        "/client/treatments/investigation/createInvestigation",
        formData,
        {
          headers: { treatmentid: ID },
        }
      );

      dispatch(addInvestigation(response.data.data));
      setformData({
        investigation: "",
        toothNo: "",
        surface: "",
        description: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Failed to submit the form.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const investigation = useSelector(
    (state: RootState) => state.diagnose.investigation
  );

  return (
    <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
      <div className="px-4 py-2.5 border-b border-slate-200 dark:border-slate-700">
        <h4 className="text-sm font-bold text-slate-800 dark:text-slate-100">Investigation</h4>
      </div>

      <div className="p-4">
        <form onSubmit={handleSubmit} className="flex flex-wrap gap-3 items-end mb-4">
          <div className="w-40">
            <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">Investigation *</label>
            <select
              name="investigation"
              value={formData.investigation}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200"
            >
              <option value="">Select</option>
              <option value="X-Ray IOPA">X-Ray IOPA</option>
              <option value="X-Ray OPG">X-Ray OPG</option>
              <option value="CBCT">CBCT</option>
              <option value="Blood Pressure">Blood Pressure</option>
              <option value="HbAIC">HbAIC</option>
              <option value="INR">INR</option>
            </select>
          </div>
          <div className="w-24">
            <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">Tooth No</label>
            <input
              name="toothNo"
              type="text"
              value={formData.toothNo}
              onChange={handleChange}
              placeholder="11"
              className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
            />
          </div>
          <div className="w-24">
            <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">Surface</label>
            <input
              name="surface"
              type="text"
              value={formData.surface}
              onChange={handleChange}
              placeholder="M, D"
              className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
            />
          </div>
          <div className="flex-1 min-w-[150px]">
            <label className="block text-xs font-medium text-slate-700 dark:text-slate-400 mb-1">Description</label>
            <input
              name="description"
              type="text"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter description"
              className="w-full px-3 py-2 rounded-lg border border-gray-600 dark:border-slate-600 focus:outline-none transition-all text-xs bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 placeholder-slate-500 dark:placeholder-slate-400"
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-4 py-2 rounded-lg bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-medium text-xs hover:shadow-lg hover:shadow-cyan-200 transition-all disabled:opacity-50"
          >
            {isSubmitting ? "Adding..." : "Add"}
          </button>
        </form>

        {investigation?.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50 dark:bg-slate-700/50 border-b border-slate-100 dark:border-slate-600">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Investigation</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Tooth No</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Surface</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Description</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Images</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase w-20">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
                {investigation?.map((item: any, i: number) => (
                  <InvTr key={item?._id ?? i} item={item} apiImage={item?.images} />
                ))}
              </tbody>
            </table>
          </div>
        )}

        {investigation?.length === 0 && (
          <div className="text-center py-4 text-slate-400 dark:text-slate-500">
            <p className="text-xs">No investigations added yet</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Investigation;
